"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbModalHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @namespace skybase-components.sb-modal.sb-modal-header
 */

/**
 * @typedef {Object} skybase-components.sb-modal.sb-modal-header#props
 *
 * @property {String} title
 * @property {Function} onCloseBtnClick
 */

/**
 * @function
 * @name skybase-components.sb-modal.sb-modal-header#SbModalHeader
 * @param  {skybase-components.sb-modal.sb-modal-header#props} props
 * @return {React.Component}
 */
var SbModalHeader = function SbModalHeader(props) {
  var onCloseBtnClick = props.onCloseBtnClick,
      title = props.title,
      closeEnabled = props.closeEnabled,
      closeButtonId = props.closeButtonId,
      id = props.id;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-modal-header fl-align-items-center",
    id: id
  }, /*#__PURE__*/_react.default.createElement("h1", null, title), onCloseBtnClick && closeEnabled && /*#__PURE__*/_react.default.createElement("div", {
    className: "close-modal",
    onClick: onCloseBtnClick,
    id: closeButtonId
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "sbi-toast-close"
  })));
};

exports.SbModalHeader = SbModalHeader;
SbModalHeader.propTypes = {
  id: _propTypes.default.string,
  closeButtonId: _propTypes.default.string,
  onCloseBtnClick: _propTypes.default.func,
  title: _propTypes.default.string,
  closeEnabled: _propTypes.default.bool
};
SbModalHeader.defaultProps = {
  id: undefined,
  title: '',
  onCloseBtnClick: null,
  closeEnabled: true,
  closeButtonId: null
};
//# sourceMappingURL=sb-modal-header.js.map